import { IAppState } from './../../types/reducers/state';

// Если цена публикации больше не 0, считаем, что она платная
export const selectIsPublicationPaid = (state: IAppState) => {
  if (state.publishTerms?.publication.period) {
    return Boolean(state.publishTerms.publication.period.price);
  }

  return;
};
